// extracted by mini-css-extract-plugin
module.exports = {"beachHomeSpecification":"style_beachHomeSpecification__3TcWI","beachSpecificationInner":"style_beachSpecificationInner__do0ew"};